<template>
  <div class="flex pt-4 lg:pt-10">
    <slot name="col-a">
      <Button
        v-if="currentStep !== 0 && !disableBack"
        class="link p-0 text-grey-dark text-sm"
        @click="$emit('prev')"
      >
        {{ backLabel }}
      </Button>
    </slot>
    <Button
      class="secondary py-1 ml-auto font-black text-base font-lato"
      :disabled="disableNext"
      :title="nextTitle"
      @click="$emit('next')"
    >
      {{ nextLabel }}
    </Button>
  </div>
</template>

<script>
export default {
  name: "OnboardingNav",

  props: {
    backLabel: {
      type: String,
      default: "Back",
    },
    currentStep: {
      type: Number,
      required: true,
    },
    disableBack: {
      type: Boolean,
      default: false,
    },
    disableNext: {
      type: Boolean,
      default: true,
    },
    nextLabel: {
      type: String,
      default: "Next",
    },
    nextTitle: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped></style>
